import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RDInputFileComponent } from './input-file.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [RDInputFileComponent],
  exports: [RDInputFileComponent]
})
export class RDInputFileModule { }
